import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { ManufacturerPrivilege, RetailerPrivilege } from 'helpers/team-user-roles';
import * as _ from 'lodash';
import { UserService } from 'services';

@Directive({
    selector: '[showForUserPrivileges]',
    standalone: false
})
export class UserPrivilegesDirective implements OnInit {
    @Input() showForUserPrivileges: {
        manufacturer?: ManufacturerPrivilege[];
        retailer?: RetailerPrivilege[];
    };

    constructor(
        private element: ElementRef,
        private renderer: Renderer2,
        private userService: UserService
    ) {}

    ngOnInit() {
        let requiredPrivileges: ManufacturerPrivilege[] | RetailerPrivilege[];
        if (this.userService.isAdmin()) {
            return;
        }
        if (this.userService.isManufacturer()) {
            requiredPrivileges = _.get(this.showForUserPrivileges, 'manufacturer');
        } else if (this.userService.isRetailer()) {
            requiredPrivileges = _.get(this.showForUserPrivileges, 'retailer');
        }

        const showForUser = _.isEmpty(requiredPrivileges) ? true : this.checkIfUserHasAccess(requiredPrivileges);

        if (!showForUser) {
            this.renderer.setStyle(this.element.nativeElement, 'display', 'none');
        }
    }

    checkIfUserHasAccess(requiredPrivileges) {
        return this.userService.hasAtLeastOnePrivilege(requiredPrivileges);
    }
}
